<div class="align-left">
  <div class="flex flex--column-reverse">
    @if (!hideTitle) {
      <div class="flex flex--middle ms-medium-b">
        @if (useH1) {
          <h1 class="font-heading-4">Hi! Please set your location and language.</h1>
        } @else {
          <h4 tabindex="0">Location and language</h4>
        }
      </div>
    }
    <div class="flex flex--align-start" [class.flex--space-between]="!hideTitle" [class.flex--end]="hideTitle">
      @if (!useH1 && !hideTitle) {
        <fcom-icon class="icon-medium ms-xsmall-r flex--self-center" [name]="SvgLibraryIcon.LANGUAGE" />
      }
      <fcom-icon-button
        *ngIf="showCloseButton"
        [icon]="{ name: SvgLibraryIcon.CLOSE_DELETE }"
        [theme]="IconButtonTheme.LIGHT_TERTIARY_GHOST"
        [size]="IconButtonSize.MEDIUM"
        [aria]="{ label: 'Close' }"
        (clickBtn)="emitClose()"
        data-testid="country-selector-close-button"
      />
    </div>
  </div>
  <div class="relative" [ngClass]="{ 'show-flag': showFlag }">
    <span
      *ngIf="showFlag"
      class="flag flag-{{ formGroup.controls.country.value | lowercase }} absolute ms-small-l z1"
    ></span>
    <fin-combo-box
      [id]="'select-country'"
      [label]="'Location'"
      [parentForm]="formGroup"
      [controlName]="'country'"
      [translationPrefix]="'countryLanguageSelectorEnOnly'"
      [options]="countryOptions"
      [searchable]="true"
      [searchLabel]="'Select or start typing'"
      [clearSearchLabel]="'Clear search'"
      [optionTemplate]="countryOptionTemplate"
      [infoText]="countryShopInfo$ | async"
      finFocus
      [autofocus]="true"
      (dropDownOpen)="updateShowFlag($event)"
      data-testid="country-selector"
    />
  </div>

  @if (!hideLanguageOptions) {
    <div>
      <fin-combo-box
        [id]="'select-language'"
        [label]="'Language'"
        [selectLabelTranslationKey]="'countryLanguageSelectorEnOnly.selectLabel'"
        [parentForm]="formGroup"
        [controlName]="'language'"
        [translationPrefix]="'countryLanguageSelectorEnOnly'"
        [options]="languageOptions$ | async"
        [selectLabel]="'Select'"
        [disableSelectOption]="(languageOptions$ | async) === undefined"
        [warningText]="countryShopWarning$ | async"
        data-testid="language-selector"
      />
    </div>
  }

  <div>
    <fcom-button
      [disabled]="!formGroup.valid"
      [mode]="ButtonMode.FILL"
      (clickBtn)="apply()"
      [text]="'Apply preferences'"
      data-testid="apply-button"
    />
  </div>
</div>

<ng-template #countryOptionTemplate let-name="name" let-value="value">
  <span class="flex ps-small fill"
    ><span class="flag flag-{{ value | lowercase }} mr-xsmall-r"></span><span>{{ name }}</span></span
  >
</ng-template>
